import { render } from "./updateClient.vue?vue&type=template&id=0c341c8e&scoped=true"
import script from "./updateClient.vue?vue&type=script&lang=js"
export * from "./updateClient.vue?vue&type=script&lang=js"

import "./updateClient.vue?vue&type=style&index=0&id=0c341c8e&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c341c8e"]])

export default __exports__